import React from 'react';
import { DndProvider as ReactDndProvider } from 'react-dnd';

// react-dnd@11 types predate React 18, where FC props no longer include children.
// Remove this shim after upgrading react-dnd to v14+.
export const DndProvider = ReactDndProvider as React.FC<
  React.ComponentProps<typeof ReactDndProvider> & {
    children?: React.ReactNode;
  }
>;
